export class Timespan {

    constructor(public hour = 0, public minute = 0, public second = 0) { }

    public static convertFromDate(date: Date): Timespan {
        return new Timespan(date.getHours(), date.getMinutes()); // REVIEW: Should seconds be used here too?
    }

    public static convertToDate(timespan: Timespan): Date {
        let date = new Date();
        date.setHours(timespan.hour);
        date.setMinutes(timespan.minute);
        date.setSeconds(timespan.second);
        return date;
    }

    public static convertTimeStringToDate(timespanString: string): Date {
        let timespan = this.convertFromString(timespanString);
        return this.convertToDate(timespan);
    }

    public static convertToTimeStringFromDate(date: Date): string {
        return this.convertToString(this.convertFromDate(date));
    }

    public static convertToString(timespan: Timespan): string {
        return Timespan.padLeft(timespan.hour.toString(), 2) + ':' + Timespan.padLeft(timespan.minute.toString(), 2) + ':' + Timespan.padLeft(timespan.second.toString(), 2);
    }

    public static convertFromString(timespanString: string): Timespan {
        let splitted = timespanString.split(':');
        let timespan = new Timespan();

        if (splitted.length > 0) {
            timespan.hour = parseInt(splitted[0]);
        }

        if (splitted.length > 1) {
            timespan.minute = parseInt(splitted[1]);
        }

        if (splitted.length > 2) {
            timespan.second = parseInt(splitted[2]);
        }

        return timespan;
    }

    static padLeft(value: string, length: number) {
        return (value.toString().length < length) ? Timespan.padLeft("0" + value, length) : value;
    }
}